import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const API_URL = environment.prismaApiUrl;

@Injectable({
  providedIn: 'root'
})
export class GenericCrudService<T> {
  protected http: HttpClient;
  
  constructor(http: HttpClient, private apiUrl: string) {
    this.http = http;
  }

  currentObject: any;
  isNew: Boolean = false;
  API_PATH = API_URL + '/' + this.apiUrl;
  

  getAll(): Observable<any> {
    return this.http.get(this.API_PATH);
  }

  show(id: any): Observable<any> {
    this.currentObject = this.http.get(this.API_PATH + '/' + id);
    return this.currentObject;
  }

  store(object: any): Observable<any> {
    return this.http.post<T>(this.API_PATH, {data: object});
  }

  delete(object: any): Observable<any> {
    return this.http.delete(this.API_PATH + '/' + object.id);
  }

  update(object: any): Observable<any> {
    return this.http.put<T>(this.API_PATH + '/' + object.id, {data: object});
  }

  genPDF(): Observable<any> {
    return this.http.get(this.API_PATH + '/gen-pdf', {responseType: 'arraybuffer'});
  }

  getCurrentObject() {
    return this.currentObject;
  }

  setIsNew(value: any) {
    this.isNew = value;
  }

  getIsNew() {
    return this.isNew;
  }
}
